import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, switchMap } from 'rxjs';
import { FinanceThreshold } from '../models/finance-threshold.model';
import { OidcSecurityService } from 'angular-auth-oidc-client';

@Injectable({
  providedIn: 'root',
})
export class FinanceThresholdService {
  private apiUrl = `/api/finance-thresholds`;

  constructor(
    private http: HttpClient,
    private oidcSecurityService: OidcSecurityService
  ) {}

  getFinanceThresholds(): Observable<FinanceThreshold[]> {
    return this.oidcSecurityService.getIdToken().pipe(
      switchMap((idToken) =>
        this.http.get<FinanceThreshold[]>(this.apiUrl, {
          headers: { Authorization: `Bearer ${idToken}` },
        })
      )
    );
  }

  createFinanceThreshold(threshold: Partial<FinanceThreshold>): Observable<FinanceThreshold> {
    // Remove isNew property before sending to backend
    const { isNew: _isNew, ...payload } = threshold;
    return this.oidcSecurityService.getIdToken().pipe(
      switchMap((idToken) =>
        this.http.post<FinanceThreshold>(this.apiUrl, payload, {
          headers: { Authorization: `Bearer ${idToken}` },
        })
      )
    );
  }

  updateFinanceThreshold(id: number, threshold: Partial<FinanceThreshold>): Observable<FinanceThreshold> {
    // Remove isNew property before sending to backend
    const { isNew: _isNew, ...payload } = threshold;
    return this.oidcSecurityService.getIdToken().pipe(
      switchMap((idToken) =>
        this.http.patch<FinanceThreshold>(`${this.apiUrl}/${id}`, payload, {
          headers: { Authorization: `Bearer ${idToken}` },
        })
      )
    );
  }

  deleteFinanceThreshold(id: number): Observable<void> {
    return this.oidcSecurityService.getIdToken().pipe(
      switchMap((idToken) =>
        this.http.delete<void>(`${this.apiUrl}/${id}`, {
          headers: { Authorization: `Bearer ${idToken}` },
        })
      )
    );
  }
}
